import config from 'Config';
import { I13N_TYPE_TIMING } from 'Lib/constants/i13nSpec';

const loadWebVital = () => import('web-vitals' /* webpackChunkName: "web-vitals" */);

type Callback = (
  type: string,
  data: {
    event_category: string;
    event_label: string;
    name: string;
    value: number;
  }
) => void;

const trackPerf = async (callback?: Callback) => {
  const webVitals = await loadWebVital();
  const perfBeaconConfig = config.perf.beacon;
  const reportPerfData = ({ name, delta, id }) => {
    if (!delta) {
      return;
    }
    const deltaValue = Math.round(name === 'CLS' ? delta * 1000 : delta);
    callback?.(I13N_TYPE_TIMING, {
      event_category: 'Web Vitals',
      event_label: id,
      name,
      value: deltaValue,
    });
  };
  Object.entries(perfBeaconConfig).forEach(([, value]) => {
    webVitals[value]?.call(webVitals, reportPerfData);
  });
};

export default trackPerf;
